import axios from "axios";

const createApi = (baseUrl) => {
  const api = axios.create({
    baseURL: baseUrl,
  });

  // Interceptor para adicionar token em todas as requisições
  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("system");
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );

  return api;
};

export const getApiInstance = (system) => {
  const baseUrl =
    system === "gscemi"
      ? process.env.REACT_APP_URL_BASE_GSCEMI
      : process.env.REACT_APP_URL_BASE_SISFUNER;

  return createApi(baseUrl);
};

export default getApiInstance;
